/* @flow */

import React from 'react';
import PropTypes from '../util/prop_types';

export default class Marker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      positionX: 0,
      positionY: 0
    };
  }

  static propTypes = {
    longitude: PropTypes.number.isRequired,
    latitude: PropTypes.number.isRequired,
    offsetLeft: PropTypes.number,
    offsetTop: PropTypes.number,
    children: PropTypes.element.isRequired,
  }

  static defaultProps = {
    offsetLeft: 0,
    offsetTop: 0,
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentDidMount() {
    this.context.map.on('move', this.handleMapMove);
    // Now this.container is rendered and the size of container is known.
    // Recalculate the anchor/position
    this.handleMapMove();
  }

  componentWillUnmount() {
    this.prevent = true;

    this.context.map.off('move', this.handleMapMove);
  }

  componentWillReceiveProps(nextProps) {
    const {longitude, latitude} = nextProps;
    if (!this.prevent) {
      const position = this.context.map.project([longitude, latitude]);
      this.setState({positionX: position.x, positionY: position.y});
    }
  }

  handleMapMove = () => {
    const {longitude, latitude} = this.props;
    if (!this.prevent) {
      const position = this.context.map.project([longitude, latitude]);
      this.setState({positionX: position.x, positionY: position.y});
    }
  };

  render(): ?React.Element<any> {
    const {offsetLeft, offsetTop, children} = this.props;

    const x = this.state.positionX + offsetLeft;
    const y = this.state.positionY + offsetTop;

    const containerStyle = {
      transform: `translate(${x.toFixed(0)}px, ${y.toFixed(0)}px)`,
      pointerEvents: 'auto'
    };

    return (
      <div
        className='mapboxgl-marker'
        style={containerStyle} >
        {children}
      </div>
    );
  }
}
